import Emoji from '@tiptap-pro/extension-emoji';
import { Code } from './Code';
import tiptapExtensionsBase from './tiptapExtensionsBase';

const tiptapExtensionsView = [...tiptapExtensionsBase, Code, Emoji];

export default tiptapExtensionsView;
